export default "__VITE_ASSET__39a61cc2__"